import { CircleCheck } from 'lucide-react';
import type { components } from '~/api/openapi';
import { ToastLayout } from '../../toast-layout';
import { interpolateXp, XpBadge } from '../icons/xp-badge';

type XpGainActionType = components['schemas']['XpGainSourceDto']['actionType'];

type GamificationEarnXpToastProps = {
  title: string;
  description: string;
  xp: number;
  actionType?: XpGainActionType;
  toastId?: string | number;
};

const DESCRIPTION_ONLY_ACTIONS: ReadonlySet<XpGainActionType> = new Set([
  'FIRST_COMMENT',
  'FIRST_EMOJI',
]);

export function GamificationEarnXpToast({
  title,
  description,
  xp,
  actionType,
  toastId,
}: GamificationEarnXpToastProps) {
  const skipDescriptionBadge = actionType != null && DESCRIPTION_ONLY_ACTIONS.has(actionType);
  const resolvedDescription = interpolateXp(description, xp);
  const hasDescriptionBadge = resolvedDescription !== description;

  return (
    <ToastLayout
      title={interpolateXp(title, xp)}
      icon={<CircleCheck className="size-10 shrink-0 fill-green-500 text-text-0" />}
      borderColor="border-green-500"
      toastId={toastId}
    >
      <div className="flex flex-wrap items-center gap-sm text-body-big">
        {skipDescriptionBadge ? description : resolvedDescription}
        {!skipDescriptionBadge && !hasDescriptionBadge ? <XpBadge xp={xp} /> : null}
      </div>
    </ToastLayout>
  );
}
